import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';

const accountID = process.env.REACT_APP_NEW_RELIC_ACCOUNT_ID;
const trustKey = process.env.REACT_APP_NEW_RELIC_TRUST_KEY || accountID;
const agentID = process.env.REACT_APP_NEW_RELIC_AGENT_ID;
const licenseKey = process.env.REACT_APP_NEW_RELIC_LICENSE_KEY;
const applicationID = process.env.REACT_APP_NEW_RELIC_APPLICATION_ID;
const beacon = process.env.REACT_APP_NEW_RELIC_BEACON || 'bam.nr-data.net';

export function startNewRelicBrowserAgent() {
  // CRA `npm start` is development; the QA image is a production build.
  // Do not send from localhost even if .env.local has browser keys.
  if (process.env.NODE_ENV !== 'production') {
    return null;
  }
  if (!accountID || !agentID || !licenseKey || !applicationID) {
    return null;
  }

  return new BrowserAgent({
    init: {
      distributed_tracing: { enabled: true },
      privacy: { cookies_enabled: true },
      ajax: { deny_list: [] },
    },
    loader_config: {
      accountID,
      trustKey,
      agentID,
      licenseKey,
      applicationID,
    },
    info: {
      beacon,
      errorBeacon: beacon,
      licenseKey,
      applicationID,
      sa: 1,
    },
  });
}
